import React from 'react';
import { motion } from 'framer-motion';
import './AboutUs.css';

const AboutUs = () => {
	// Animation Variants
	const sectionVariants = {
	  hidden: { opacity: 0, y: 50 },
	  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
	};
  
	const boxVariants = {
	  hidden: { opacity: 0, x: -100 },
	  visible: { opacity: 1, x: 0, transition: { duration: 0.6 } },
	  hover: { scale: 1.05, transition: { duration: 0.3 } },
	};
  
	return (
	  <div className="enhanced-about-us-container" id='about'>
		{/* Hero Section */}
		<motion.div
		  className="hero-section"
		  variants={sectionVariants}
		  initial="hidden"
		  animate="visible"
		>
		  <h1>Welcome to <span className="highlight">Peru-Tech</span></h1>
		  <p>Your trusted partner for high-quality Machine Manufacturing, Servicing and spare parts.</p>
		</motion.div>
  
		{/* Content Sections */}
		<div className="content-sections">
		  {/* Mission Section */}
		  <motion.div
		className="content-box mission-box updated-mission-box"
		variants={boxVariants}
		initial="hidden"
		animate="visible"
		whileHover="hover"
		>
		<div className="mission-content">
			<h2>Our Mission</h2>
			<p>
				To manufacture high-quality industrial equipment and conveyor systems that deliver reliability, efficiency, and lasting value to our customers.			</p>
		</div>
		</motion.div>
  
		  {/* What We Offer Section */}
		  <motion.div
			className="content-box offerings-box updater_box"
			variants={boxVariants}
			initial="hidden"
			animate="visible"
			whileHover="hover"
		  >
		<h2>What We Offer</h2>
<div className="offerings-grid">
  <div className="offering-item">
    <h3>Conveyor Manufacturing</h3>
    <p>Custom-designed conveyor systems engineered for efficiency, durability, and productivity.</p>
  </div>

  <div className="offering-item">
    <h3>Material Handling Solutions</h3>
    <p>End-to-end material handling equipment tailored to your industrial requirements.</p>
  </div>

  <div className="offering-item">
    <h3>Custom Fabrication</h3>
    <p>Precision fabrication and assembly services for specialized industrial applications.</p>
  </div>

  <div className="offering-item">
    <h3>Installation & Commissioning</h3>
    <p>Professional installation and setup to ensure smooth and reliable operation.</p>
  </div>

  <div className="offering-item">
    <h3>Maintenance Services</h3>
    <p>Preventive maintenance and technical support to maximize equipment lifespan.</p>
  </div>

  <div className="offering-item">
    <h3>Spare Parts Supply</h3>
    <p>High-quality replacement parts and components for uninterrupted production.</p>
  </div>
</div>
  </motion.div>
		  {/* Why Choose Us Section */}
		  <motion.div
			className="content-box why-choose-us-box updater_box"
			variants={boxVariants}
			initial="hidden"
			animate="visible"
			whileHover="hover"
		  >
			<h2>Why Choose Us?</h2>
			<ul>
			   <li>
    <strong>Manufacturing Excellence:</strong>
    Precision-engineered products built to meet the highest industry standards.
  </li>

  <li>
    <strong>Customized Solutions:</strong>
    Conveyor and material handling systems tailored to your specific operational needs.
  </li>

  <li>
    <strong>Quality & Reliability:</strong>
    Robust manufacturing processes ensure durable, high-performance equipment.
  </li>

  <li>
    <strong>On-Time Delivery:</strong>
    Efficient production planning and execution to keep your projects on schedule.
  </li>

  <li>
    <strong>Technical Expertise:</strong>
    Experienced engineers and skilled professionals dedicated to innovative manufacturing solutions.
  </li>

  <li>
    <strong>After-Sales Support:</strong>
    Comprehensive installation, maintenance, and technical assistance for long-term success.
  </li>
			</ul>
		  </motion.div>
		</div>
  
		{/* Call to Action */}
		<motion.div
		  className="cta-section"
		  variants={sectionVariants}
		  initial="hidden"
		  animate="visible"
		>
		  <p>
			At <span className="highlight">Peru-Tech</span>, we are your partner in productivity. Trust us to keep your machines running efficiently and your business moving forward.
		  </p>
		 
		</motion.div>
	  </div>
	);
  };

export default AboutUs;
